import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ActionModal, FormField, Modal, TextInput } from '@percent/lemonade'
import { type Err, useCreateCampaignGroup } from './useCreateCampaignGroup'

export type CreateGroupModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  onSuccess: () => void
  onError: (error?: Err) => void
}>

export function CreateGroupModal({ isOpen, handleClose, onSuccess, onError }: CreateGroupModalProps) {
  const { t } = useTranslation()
  const [name, setName] = useState('')

  const { isLoading, createGroup } = useCreateCampaignGroup({
    onCreated: () => {
      setName('')
      onSuccess()
    },
    onError: (error: Err) => {
      onError(error)
    }
  })

  const onClose = () => {
    setName('')
    handleClose()
  }

  return (
    <Modal open={isOpen} onClose={onClose}>
      <ActionModal
        title={t('typography.createGroupTitle')}
        primaryButtonText={t('button.createGroup')}
        secondaryButtonText={t('button.cancel')}
        handleClose={onClose}
        handleSubmit={() => createGroup(name)}
        loading={isLoading}
        disabled={!name.trim()}
      >
        <FormField label={t('typography.groupNameLabel')} necessity="required">
          <TextInput
            name="groupName"
            value={name}
            placeholder={t('typography.groupNamePlaceholder')}
            onChange={e => setName(e.target.value)}
            maxLength={120}
            data-testid="create-group-name-input"
          />
        </FormField>
      </ActionModal>
    </Modal>
  )
}
